import { gql } from '@apollo/client';

export type { GetApiKeys as IGetApiKeys } from './__generated__/GetApiKeys';

export const GET_API_KEYS = gql`
  query GetApiKeys {
    getPartnerAuthTokens {
      token
      createdAt
    }
  }
`;
